import { useKpiTracker, useSession } from "@pocketrocketgmbh/kpi-tracker";
import type {
  KpiTrackerConfig,
  UseKpiTrackerReturn,
  UseSessionReturn,
} from "@pocketrocketgmbh/kpi-tracker";
import { watch } from "vue";
import { useGlobalStore } from "@/stores/global";
import { getGameApiBaseUrl } from "@/services/gameApi";

const config: KpiTrackerConfig = {
  gameId: process.env.VUE_APP_GAME_ID || "test-game-id",
  apiUrl: getGameApiBaseUrl(),
  apiUsername: process.env.VUE_APP_API_USERNAME,
  apiPassword: process.env.VUE_APP_API_PASSWORD,
};

// Singleton-Instanzen
let kpiTrackerInstance: UseKpiTrackerReturn | null = null;
let sessionInstance: UseSessionReturn | null = null;

export function useGameTracking() {
  // Erstelle Singleton-Instanzen nur einmal
  if (!kpiTrackerInstance || !sessionInstance) {
    kpiTrackerInstance = useKpiTracker(2);
    sessionInstance = useSession(config, kpiTrackerInstance);
  }

  // Watcher in jedem Setup-Kontext erstellen (Vue braucht das für Reaktivität)
  const globalStore = useGlobalStore();

  // Synchronisiere timesLeftToPlay im Store wenn selectedPerson geändert wird
  watch(
    () => kpiTrackerInstance!.selectedPerson.value,
    (newPerson) => {
      globalStore.resetGame(newPerson);
    }
  );

  // Synchronisiere timesLeftToPlay im Store wenn es im Package geändert wird
  watch(
    () => kpiTrackerInstance!.timesLeftToPlay.value,
    (newValue) => {
      globalStore.setTimesLeftToPlay(newValue);
    }
  );

  return {
    kpiTracker: kpiTrackerInstance,
    session: sessionInstance,
  };
}
